import React from 'react';

type ChoosePlanHeaderProps = {
  description?: string;
};

const ChoosePlanHeader = ({ description }: ChoosePlanHeaderProps) => {
  return (
    <div className="mb-32 px-16 text-center sm:mb-48 sm:px-0">
      <h1 className="font-suisse-works mb-16 mt-0 text-headline-md xs:text-headline-lg sm:text-headline-lg">
        Choose the plan that’s right for you
      </h1>
      <h3 className="font-suisse-neue m-0 text-body-lg xs:text-[16px]">
        {description ||
          'Join high-powered tech and business leaders who read The Information every day.'}
      </h3>
    </div>
  );
};

export default ChoosePlanHeader;
